import { hbs } from 'ember-cli-htmlbars';
export default hbs("<span\n  id={{@id}}\n  class=\'text-sm text-gray-500\'\n  data-test-input-group-optional-text\n  ...attributes\n>\n  {{yield}}\n</span>")